// extracted by mini-css-extract-plugin
export default {"calculatedRow":"BoDQ4hD7kPZXZKhfjIm6"};